/**
 * @file import页面
 * @author tianzhu(tianzhu@baidu.com)
 */

module.exports = file => () => import('@/views/' + file + '.vue');
